import React from "react";


import MovieSearch from "../components/MovieSearch";


const HomePage = () => {
 

  return <MovieSearch  />;
};

export default HomePage;
